import React from 'react';
import { 
    TableContainer, 
    Table, 
    TableHead, 
    TableRow, 
    TableCell, 
    TableBody, 
    Skeleton
} from '@mui/material';

const UserActionTableSkeleton: React.FC = () => {
    return (
        <TableContainer
            sx={{
                borderRadius: '12px',
                backgroundColor: '#FAF9F9',
            }}
        >
            <Table>
                <TableHead>
                    <TableRow>
                        {['Action', 'Account Number', 'SA ID', 'User', 'Timestamp'].map((head) => (
                            <TableCell
                                key={head}
                                sx={{
                                    color: '#49454F',
                                    fontWeight: 600,
                                    fontSize: '12px',
                                    borderBottom: 'none',
                                    backgroundColor: "#fff"
                                }}
                            >
                                {head}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({ length: 5 }).map((_, index) => (
                        <TableRow
                            key={index}
                            sx={{
                                backgroundColor: '#FAF9F9',
                                height: 56,
                                borderRadius: '12px',
                            }}
                        >
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={80}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={100}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={80}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={90}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                            <TableCell>
                                <Skeleton
                                    variant="text"
                                    width={120}
                                    height={20}
                                    sx={{ backgroundColor: '#f0f0f0' }}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default UserActionTableSkeleton;
